import clsx from 'clsx'
import React from 'react'

import './RadioGroup.scss'

const RadioGroup = ({
   className,
   selectedOption,
   setSelectedOption,
   options,
   isDarkTheme,
}) => {
   return (
      <div
         className={clsx(
            'RadioGroup',
            className,
            isDarkTheme && 'RadioGroup--dark'
         )}
      >
         {options.map(option => (
            <div
               className={clsx(
                  'RadioGroup__tab',
                  selectedOption?.id === option.id && 'RadioGroup__tab--active'
               )}
               key={option.id}
               role="button"
               tabIndex={0}
               onClick={() => setSelectedOption(option)}
            >
               {option.title}
            </div>
         ))}
      </div>
   )
}

export default RadioGroup
